<section class="py-5">
  @let schedule = weeklySchedule();
  <app-button-middle-office type="DISCONNECT" />
  <div class="centered-with-padding grid grid-cols-1 gap-[14px] desk:grid-cols-[auto_400px]">
    <div class="flex h-full flex-col justify-center rounded-[30px] bg-gray-light p-5 desk:self-start desk:p-[30px]">
      <app-title [title]="titleStoreName()" size="custom-40" />
      @if (schedule?.operationalStatus?.code !== "OPENING_SOON" && data.reviewStats.totalReviews > 0) {
        <div class="mt-4 font-title leading-[42px]">
          <span class="text-[35px] desk:text-[47px]">{{ data.reviewStats.averageRating | number: "1.1-1" }}</span>
          <span class="text-[25px] desk:text-[30px]">/5</span>
        </div>
        <div class="mb-1 flex items-center gap-x-1.5">
          <app-svg [width]="12" src="assets/logos/svg/google.svg" />
          <span class="font-[500] leading-[19px]">{{ data.reviewStats.totalReviews }} avis</span>
        </div>

        @let buttonLabel = "COMPONENT.ENCART-INFOS-MAGASIN.SHOW_ALL_REVIEWS" | translate;
        @let gtm = data.gtmConfigReviewBtn;
        <a
          (click)="
            showAllReviews();
            emitGtmEvent({
              event: gtm?.event,
              group: gtm?.group,
              description: gtm?.description,
              context: gtm?.context,
              button_text_value: buttonLabel,
              event_type: 'click',
            })
          "
          class="drop-shadow-custom flex h-[36px] w-fit cursor-pointer items-center rounded-[10px] bg-anis px-[26px] py-[5px] font-bold leading-[19px]">
          {{ buttonLabel }}
        </a>
      }
    </div>

    <div class="relative z-10 gap-x-2.5 rounded-[30px] bg-gray-light px-5 py-[30px] desk:px-0 desk:py-[50px]">
      <div class="relative flex h-full flex-col gap-y-2.5 desk:justify-between">
        <div class="flex justify-between gap-2.5 desk:px-8">
          <div class="flex items-center gap-x-2.5">
            <app-svg [width]="22" src="assets/icons/pin.svg" />
            <div>
              <div class="font-bold">{{ data.store.streetName }}</div>
              <div class="font-bold">{{ data.store.zipcode }} {{ data.store.city }}</div>
            </div>
          </div>
          <div>
            <a
              [href]="googleMapLink()"
              class="drop-shadow-custom inline-block cursor-pointer rounded-[11px] bg-anis p-[10px]"
              target="_blank">
              <app-svg [inline]="true" [width]="16" src="assets/icons/directions.svg" />
            </a>
          </div>
        </div>
        <div class="flex items-center gap-x-2.5 desk:px-8">
          <app-svg [width]="22" src="assets/icons/phone.svg" />
          <a [href]="phone().telLink" class="font-bold">{{ phone().formatted }}</a>
        </div>
        @if (isStoreScheduleLoaded() && schedule) {
          <div class="relative flex flex-col gap-y-2.5">
            <div
              (click)="onDisplaySchedule()"
              (clickOutside)="isScheduleDisplayed.set(false)"
              [class.cursor-pointer]="!schedule?.operationalStatus"
              class="grid grid-cols-[1fr_auto] items-center desk:px-8">
              <div class="flex items-center gap-x-2.5">
                @if (isMiddleOfficeAvailable()) {
                  <app-button-middle-office
                    (click)="$event.stopPropagation(); $event.preventDefault()"
                    type="EDIT_SCHEDULES" />
                }
                <app-svg [width]="22" src="assets/icons/hour.svg" />
                <div class="flex flex-col">
                  <span class="font-bold">{{
                    schedule?.operationalStatus
                      ? schedule?.operationalStatus?.message
                      : schedule.storeStatus.isOpenToday
                        ? ("GLOBAL.STORE_OPEN_TODAY" | translate)
                        : ("GLOBAL.STORE_CLOSED_TODAY" | translate)
                  }}</span>
                  @if (schedule?.storeStatus?.isOpenToday && !schedule?.operationalStatus) {
                    <span>{{ schedule.storeStatus.hoursToday }}</span>
                  }
                </div>
              </div>
              @if (!schedule?.operationalStatus) {
                <app-svg
                  [height]="17"
                  [ngClass]="{ 'rotate-90': isScheduleDisplayed() }"
                  [width]="9"
                  class="transition-transform duration-300 ease-in-out"
                  src="assets/icons/caret-right.svg" />
              }
            </div>

            @if (isScheduleDisplayed()) {
              <div
                class="grid w-full grid-cols-[1fr_auto] rounded-b-[30px] desk:absolute desk:top-[50px] desk:bg-gray-light desk:px-8 desk:pb-[30px]">
                @for (dailySchedule of schedule.formattedScheduleDay; track $index) {
                  <span class="font-bold">{{ dailySchedule.translatedDay }}</span>
                  <span>{{ dailySchedule.openingHours }}</span>
                }
                @if (schedule.exceptionalClosures; as exceptionalClosures) {
                  <span class="col-span-2 py-1.5 font-bold">
                    {{ "COMPONENT.ENCART-INFOS-MAGASIN.EXCEPTIONAL_CLOSURE" | translate }}
                  </span>
                  <span [innerHtml]="exceptionalClosures" class="col-span-2"></span>
                }
                @if (schedule?.exceptionalOpenings; as exceptionalOpenings) {
                  <span class="col-span-2 py-1.5 font-bold">
                    {{ "COMPONENT.ENCART-INFOS-MAGASIN.EXCEPTIONAL_OPENING" | translate }}
                  </span>
                  <span [innerHtml]="exceptionalOpenings" class="col-span-2"></span>
                }
              </div>
            }
          </div>
        } @else {
          <app-loader [text]="'GLOBAL.LOADING_OPENING_HOURS' | translate" />
        }
      </div>
    </div>
  </div>
</section>
